import { Pipe, PipeTransform } from '@angular/core';
import { StatesHelper } from 'src/app/states/states.helper';

@Pipe({
  name: 'getStoreName'
})
export class GetStoreNamePipe implements PipeTransform {

  stores = StatesHelper.storesEntitiesState.entitiesArray;

  transform(storeId: number): string {
    return this.stores?.length && this.stores.find((store) => store.id == storeId)?.name;
  }
}